import React from 'react';
// import { withRouter } from "react-router-dom";
import {
  Container,
  FormGroup,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import UserService from 'services/UserService';

import api from '../../../services/api';
import logoCrevettic2 from '../../../images/logo1.1.png';
import logoBludocc2 from '../../../images/bludocc-logo2.png';
import { loginAdmin } from '../../../services/auth';
import Email from '../../../components/Email.js';
import LoginButton from '../../../components/Buttons/LoginButton';
import { setNameProperty } from '../../../redux/nameProperty';
import { setNameUser } from '../../../redux/nameUser';
import { setAuthentication } from '../../../redux/authenticated';
import { setDisable } from '../../../redux/disable';
import { setLoading } from '../../../redux/loading';
import { useStyles } from '../../../components/Styles';
import Error from '../../../components/Snack/Error';
import { setUserPermissions } from '../../../redux/userPermissions';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const history = useHistory();
    return <Component history={history} {...props} />;
  }
  return Wrapper;
};

function SignIn() {
  const [showPassword, setShowPassword] = React.useState(false);
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();

  const dispatch = useDispatch();
  const history = useHistory();

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required('Campo Obrigatório'),
      password: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      request(values);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // envia os dados para api salvar no banco
  async function request(data) {
    try {
      const { email, password } = data;
      global.loading = true;
      const response = await loginAdmin({ email, password });
      global.loading = false;
      localStorage.setItem('email', email);
      global.loading = true;

      const user = await UserService.currentUser();
      //
      localStorage.setItem('username', user.first_name);
      dispatch(setNameUser(user.first_name));
      dispatch(setAuthentication(true));
      dispatch(setUserPermissions(user.permissions));
      //

      const resp = await api.get('/properties');
      if (resp.data.length !== 0) {
        localStorage.setItem('idProperty', resp.data.id);
        localStorage.setItem('nameProperty', resp.data.name);
        dispatch(setNameProperty(resp.data.name));
        history.push('/home');
      } else {
        history.push('/first-property');
      }
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <div>
      <Container>
        <form className={classes.root} onSubmit={formik.handleSubmit}>
          <Typography
            style={{ marginBottom: 0 }}
            variant="h6"
            align="center"
            gutterBottom
          >
            <img
              alt="Logo"
              style={{ maxHeight: '210px', paddingTop: '80px' }}
              src={
                process.env.REACT_APP_PLATAFORM === 'crevettic'
                  ? logoCrevettic2
                  : logoBludocc2
              }
            />
          </Typography>
          <FormGroup>
            <TextField
              id="formGridName"
              label="Email"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="email"
              placeholder="Endereço de e-mail"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={!!(formik.touched.email && formik.errors.email)}
              helperText={
                formik.touched.email &&
                formik.errors.email &&
                formik.errors.email
              }
            />
          </FormGroup>
          <FormGroup>
            <TextField
              id="formGridResp"
              label="Senha"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="password"
              placeholder="Senha"
              type={showPassword ? 'text' : 'password'}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={!!(formik.touched.password && formik.errors.password)}
              helperText={
                formik.touched.password &&
                formik.errors.password &&
                formik.errors.password
              }
            />
          </FormGroup>
          <FormGroup>
            <LoginButton disabled={disable} />
          </FormGroup>
        </form>
        <hr />
        <div className="button-newpass">
          {' '}
          <Email />{' '}
        </div>
      </Container>
    </div>
  );
}

export default withRouter(SignIn);
